import { render, staticRenderFns } from "./head_dj.vue?vue&type=template&id=3c4f427b&scoped=true&"
import script from "./head_dj.vue?vue&type=script&lang=js&"
export * from "./head_dj.vue?vue&type=script&lang=js&"
import style0 from "./head_dj.vue?vue&type=style&index=0&id=3c4f427b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4f427b",
  null
  
)

export default component.exports